import React from 'react';
import { getQuotationHtml } from './QuotationHtml';

function QuotationPrint({ componentRef, quotationDetails }) {
    return (
        <div ref={componentRef} style={{ padding: 20 }}>
            <div dangerouslySetInnerHTML={{
                __html: getQuotationHtml(quotationDetails)
            }}>

            </div>
        </div>
    );
}

export default QuotationPrint;
